import { Button } from "../components";

export interface PagerProps {
  total: number;
  limit: number;
  offset: number;
  onOffset: (offset: number) => void;
}

/** Simple offset pager for paged tables (Prev / "1–50 of 312" / Next). */
export function Pager({ total, limit, offset, onOffset }: PagerProps) {
  if (total <= limit && offset === 0) return null;
  const from = Math.min(offset + 1, total);
  const to = Math.min(offset + limit, total);
  return (
    <div className="actions" style={{ padding: "12px 18px" }}>
      <span className="sub" style={{ marginTop: 0 }}>
        {from}–{to} of {total}
      </span>
      <Button mini disabled={offset === 0} onClick={() => onOffset(Math.max(0, offset - limit))}>
        Prev
      </Button>
      <Button mini disabled={to >= total} onClick={() => onOffset(offset + limit)}>
        Next
      </Button>
    </div>
  );
}
